import PageSection from '@c/listing/shared/PageSection';
import { PhotoSelect } from './PhotoSelect';
import { VideoSelect } from './VideoSelect';
import { useCreateListing } from '../_context';
import { CheckIcon } from '@heroicons/react/20/solid';
import MobilePhotoSelect from './MobilePhotoSelect';

export const MediaSelect = () => {
  const { form } = useCreateListing();

  return (
    <PageSection
      title="Product Photos"
      error={
        form.formState.errors.images?.message ||
        form.formState.errors.video?.message
      }
    >
      <div className="mt-8">
        <div className="flex w-full flex-col justify-between gap-x-[4rem] sm:flex-row">
          <div className="hidden sm:flex">
            <PhotoSelect />
          </div>

          <div className="flex sm:hidden">
            <MobilePhotoSelect />
          </div>

          <div className="mt-[3.85rem] hidden sm:flex">
            <VideoSelect />
          </div>

          <div className="mt-16 hidden w-fit flex-col gap-y-6 sm:mt-0 sm:flex">
            <h3 className="w-full text-[2rem] font-medium text-zinc-700">
              Upload best photos to increase selling & engagement.
            </h3>

            <CheckItem text="Clean and declutter the background" />
            <CheckItem text="Use natural light" />
            <CheckItem text="Experiment with angles" />
          </div>
        </div>
      </div>
    </PageSection>
  );
};

export const CheckItem = ({ text }: { text: string }) => {
  return (
    <div className="flex items-start gap-x-2">
      <CheckIcon className="h-10 w-10 text-brand-secondary" />
      <span className="w-[40rem] text-[1.8rem] text-zinc-700">{text}</span>
    </div>
  );
};
